export default __webpack_public_path__ + "static/media/4.80825b82.jpg";